import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button, Modal, PageHeaderLogo } from '../ui';
import { selectDocs } from '../features/webshop/globalSlice';
import { TAC } from "../features/webshop/components/CopyForTaC";
import { useUser } from '../features/auth/hooks';

const ShowTermsAndConditions = () => {
  const { t } = useTranslation();

  const docs = useSelector(selectDocs)
  const [openTAC, setOpenTAC] = useState(false);

  const { termsAndConditions } = docs;
  const user = useUser();
  const language = user?.locale || 'en_US';
  const pageContent = TAC[language] || TAC['en_US'];

  const handleToggleTAC = useCallback(() => {
    setOpenTAC(!openTAC)
  }, [openTAC])

  return (<>
    <Button $asText onClick={handleToggleTAC}>{t('globals.termsAndConditions')}</Button>
    <Modal
      onClose={handleToggleTAC}
      open={openTAC}
      titleChildren={
        <PageHeaderLogo lightBackground />
      }
    >
      {!!termsAndConditions ? <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />
        : <div>{pageContent}</div>}

    </Modal>
  </>

  );
}

export default ShowTermsAndConditions;

